import { actionConstants } from 'redux-layer/constants';
import {
  startReqActionType,
  successReqActionType,
  failReqActionType,
  apiHeader,
  processResponse
} from 'helper/requestHelper';
import { getEnvironment } from 'helper/utils';
import { NotificationManager } from 'react-notifications';

export const paginatedListWorkflows = (params, reset) => async dispatch => {
  dispatch({
    type: startReqActionType(actionConstants.PAGINATED_LIST_WORKFLOW)
  });
  const requestOptions = {
    method: 'GET',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}workflow?${params}`,
      requestOptions
    );
    const data = await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.PAGINATED_LIST_WORKFLOW),
      payload: { ...data, reset }
    });
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.PAGINATED_LIST_WORKFLOW)
    });
  }
};

export const getWorkflowDetail = id => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.GET_WORKFLOW_DETAIL) });
  const requestOptions = {
    method: 'GET',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}workflow/${id}`,
      requestOptions
    );
    const data = await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.GET_WORKFLOW_DETAIL),
      payload: data
    });
  } catch (error) {
    dispatch({ type: failReqActionType(actionConstants.GET_WORKFLOW_DETAIL) });
  }
};

export const copyWorkflow = payload => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.COPY_CONTENT) });

  const requestOptions = {
    method: 'POST',
    headers: apiHeader(),
    body: JSON.stringify(payload)
  };

  const url = `${getEnvironment().API_URL}workflow/copy`;

  try {
    const data = await fetch(url, requestOptions);
    const retData = await processResponse(data);
    dispatch({
      type: successReqActionType(actionConstants.COPY_CONTENT),
      payload: retData
    });
    NotificationManager.success(
      'New ID of copied workflow is ' + retData.id,
      'Succeed to Copy Workflow',
      3000,
      () => {
        document.location.href = '/workflow/' + retData.id;
      }
    );
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.COPY_CONTENT),
      error: error.message
    });
  }
};

export const deleteWorkflow = workflowId => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.DELETE_WORKFLOW) });
  const requestOptions = {
    method: 'DELETE',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}workflow/${workflowId}`,
      requestOptions
    );
    await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.DELETE_WORKFLOW),
      payload: workflowId
    });
    NotificationManager.success(
      'Workflow deleted successfully',
      'Success',
      3000
    );
  } catch (error) {
    dispatch({ type: failReqActionType(actionConstants.DELETE_WORKFLOW) });
    NotificationManager.error('Failed to delete workflow', 'Error', 3000);
  }
};
